import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown, ArrowUp, ArrowDown } from "lucide-react";

export default function ScoreMovement({ movement = [], net = 0, from, to }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="card p-5" data-testid="score-movement">
      <button onClick={() => setOpen((o) => !o)} className="w-full flex items-center justify-between focus-ring rounded-lg" data-testid="score-movement-toggle">
        <div className="flex items-center gap-3 flex-wrap">
          <span className="text-sm font-bold text-ink">Why did my score change?</span>
          <span className="text-xs text-ink-2">{from} → <span className="font-bold text-ink">{to}</span> this month</span>
        </div>
        <span className="flex items-center gap-2 shrink-0">
          <span className="inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-bold" style={{ background: "rgba(147,192,32,.12)", color: "#5F8213" }}>{net >= 0 ? "+" : ""}{net} net</span>
          <ChevronDown size={16} className={`transition-transform ${open ? "rotate-180" : ""}`} style={{ color: "#9A9C90" }} />
        </span>
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} className="overflow-hidden">
            <div className="mt-4 space-y-2.5">
              {movement.map((m, i) => (
                <div key={i} className="flex items-center gap-3" data-testid={`movement-${m.pillar}`}>
                  <span className="inline-flex items-center justify-end gap-0.5 text-sm font-bold w-10 shrink-0" style={{ color: m.delta >= 0 ? "#5F8213" : "#D0526B" }}>
                    {m.delta > 0 ? <ArrowUp size={13} strokeWidth={2.5} /> : m.delta < 0 ? <ArrowDown size={13} strokeWidth={2.5} /> : null}{m.delta >= 0 ? "+" : ""}{m.delta}
                  </span>
                  <span className="text-sm font-semibold text-ink w-40 shrink-0">{m.label}</span>
                  <span className="text-sm text-ink-2">{m.reason}</span>
                </div>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
